import React from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import vipImg from "../../assets/images/vip-circle-img.png";

const VipCircle = () => {
    return (
        <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <div className="border border-black-10 rounded-lg w-full mx-auto sm:m-0 rounded-tl-lg rounded-tr-lg">
                    <div className="mb-2.5 relative rounded-tl-lg rounded-tr-lg">
                        <img
                            src={vipImg}
                            className="w-full rounded-tl-lg rounded-tr-lg"
                            alt=""
                        />
                        <div className="absolute top-0 left-0 right-0 w-full bottom-0 flex flex-col justify-between bg-black bg-opacity-10 cursor-pointer">
                            <div className="px-2 pt-2.5 flex items-start justify-end text-white">
                                <BsThreeDotsVertical className="text-2xl cursor-pointer" />
                            </div>
                        </div>
                    </div>
                    <div className="px-4 pb-4">
                        <h4 className="text-base font-bold text-ebony-color mb-0.5">
                            Security pass
                        </h4>
                        <div className="flex items-center flex-wrap gap-x-3 gap-y-1 text-sm text-black-60 mb-3.5">
                            <span>MYR 10/month</span>
                            <span>MYR 120/Year</span>
                            <span>1st VIP circle</span>
                        </div>
                        <div className="">
                            <button className="bg-orange-color text-white py-1.5 px-[15px] rounded-lg text-sm font-medium">
                                View Live
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VipCircle;
